/** Espaço reservado das telas que ainda não foram construídas nesta volta. */

export function Vazio({ titulo, semana, o_que }: { titulo: string; semana: string; o_que: string }) {
  return (
    <div
      style={{
        flex: 1, minHeight: 0, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 8, padding: 40, textAlign: "center",
      }}
    >
      <span
        style={{
          fontFamily: "var(--fm)", fontSize: 10.5, letterSpacing: ".12em",
          textTransform: "uppercase", color: "var(--txt3)",
        }}
      >
        {semana}
      </span>
      <h2 style={{ margin: 0, fontSize: 19, fontWeight: 600, letterSpacing: "-.01em" }}>{titulo}</h2>
      <p style={{ margin: 0, maxWidth: "52ch", fontSize: 13, color: "var(--txt2)", lineHeight: 1.55 }}>{o_que}</p>
    </div>
  )
}
